import styled, { keyframes } from 'styled-components';
import { zoomIn } from 'react-animations';
import { media } from '../../styles/theme';

const animationType = keyframes`${zoomIn}`;

export const Container = styled.main`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100dvh;
  padding: ${({ theme }) => theme.espaco.lg} ${({ theme }) => theme.espaco.lg} 72px;
  background:
    linear-gradient(180deg, ${({ theme }) => theme.cores.primary} 0 38%, ${({ theme }) => theme.cores.surface} 38% 100%);
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: ${({ theme }) => theme.espaco.md};
  width: 100%;
  max-width: 420px;
  padding: ${({ theme }) => theme.espaco.xxl};
  background-color: ${({ theme }) => theme.cores.card};
  border: 1px solid ${({ theme }) => theme.cores.border};
  border-radius: ${({ theme }) => theme.raio.card};
  box-shadow: ${({ theme }) => theme.sombra.modal};
  animation: 0.5s ${animationType};
  text-align: center;

  img {
    align-self: center;
    height: 56px;
    width: auto;
    margin-bottom: ${({ theme }) => theme.espaco.sm};
  }

  h1 {
    font-size: ${({ theme }) => theme.fonte.h1};
    color: ${({ theme }) => theme.cores.ink};
  }

  h4 {
    margin-bottom: ${({ theme }) => theme.espaco.sm};
    color: ${({ theme }) => theme.cores.inkSecondary};
    font-weight: 400;
  }

  .empresa {
    margin-top: -${({ theme }) => theme.espaco.sm};
    color: ${({ theme }) => theme.cores.inkMuted};
    font-size: ${({ theme }) => theme.fonte.small};
  }

  ${media.mobile} {
    padding: ${({ theme }) => theme.espaco.xl} ${({ theme }) => theme.espaco.lg};

    h1 {
      font-size: ${({ theme }) => theme.fonte.h2};
    }
  }
`;

export const LinkTexto = styled.button`
  align-self: center;
  padding: ${({ theme }) => theme.espaco.sm};
  border: none;
  background: transparent;
  color: ${({ theme }) => theme.cores.primary};
  font-size: ${({ theme }) => theme.fonte.small};

  &:hover {
    text-decoration: underline;
  }
`;
